import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';

import { DASHBOARD_BASE_PATH, DASHBOARD_HOME_PATH, DASHBOARD_INSIGHTS_BASE_PATH , DASHBOARD_RECOMMENDATIONS_PATH, DASHBOARD_OFFERS_PATH, DASHBOARD_PROFILE_PATH, DASHBOARD_SURVEY_PATH, DASHBOARD_CALCULATOR_PATH, DASHBOARD_SETTINGS_PATH, DASHBOARD_FAQS_PATH, DASHBOARD_SOLAR_PATH, DASHBOARD_HOME_ADVISOR_PATH, DASHBOARD_MARKETPLACE_PATH} from '../../constants/paths';
import HomePageMain from './homePage/HomePageMain';
import InsightsPageMain from './insightsPage/InsightsPageMain';
import RecommendationsPageMain from './recommendationsPage/RecommendationsPageMain';
import OffersPageMain from './offersPage/OffersPageMain';
import ProfilePageMain from './profilePage/ProfilePageMain';
import SurveyPageMain from './surveyPage/SurveyPageMain';
import WhatIfCalcPageMain from './whatIfCalcPage/WhatIfCalcPageMain';
import SettingsPreferencesPageMain from './settingsPage/SettingsPreferencesPageMain';
import FAQsPageMain from './FAQPage/FAQsPageMain';
import ErrorMain from "../common/Error/ErrorMain";
import HomeAdvisorContainer from './HomeAdvisor/HomeAdvisorContainer';
import { withRouter } from 'react-router-dom';
import SolarPageMain from './solarPage/SolarPageMain';
import MarketplaceContainer from './Marketplace/MarketplaceContainer';

class DashboardMain extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      //After page load, go to top of the page.
      //After loading this page, if the user scrolls to the bottom, goes to some other page, and then comes back to this page, the scroll position is at the bottom, whereas it should load from top.
      window.scrollTo(0, 0);
    }
  }

  render(){
    return(
      <Switch>
        <Redirect exact from={DASHBOARD_BASE_PATH} to={DASHBOARD_HOME_PATH} />
        <Route exact path={DASHBOARD_HOME_PATH} component={HomePageMain}/>
        <Route path={DASHBOARD_INSIGHTS_BASE_PATH} component={InsightsPageMain}/>
        <Route exact path={DASHBOARD_RECOMMENDATIONS_PATH} component={RecommendationsPageMain}/>
        <Route exact path={DASHBOARD_OFFERS_PATH} component={OffersPageMain}/>
        <Route exact path={DASHBOARD_PROFILE_PATH} component={ProfilePageMain}/>
        <Route exact path={DASHBOARD_SURVEY_PATH} component={SurveyPageMain}/>
        <Route exact path={DASHBOARD_CALCULATOR_PATH} component={WhatIfCalcPageMain}/>
        <Route path={DASHBOARD_SETTINGS_PATH} component={SettingsPreferencesPageMain}/>
        <Route exact path={DASHBOARD_FAQS_PATH} component={FAQsPageMain}/>
        <Route exact path={DASHBOARD_SOLAR_PATH} component={SolarPageMain}/>
        <Route exact path={DASHBOARD_HOME_ADVISOR_PATH} component={HomeAdvisorContainer}/>
        <Route exact path={DASHBOARD_MARKETPLACE_PATH} component={MarketplaceContainer}/>
        <Route component={ErrorMain}/>
      </Switch>
    );
  }
}

export default withRouter(DashboardMain);
